import * as styled from "styled-components";

import PoppinsLight300 from "../assets/fonts/Poppins/Poppins-Light.ttf";
import PoppinsRegular400 from "../assets/fonts/Poppins/Poppins-Regular.ttf";
import PoppinsMedium500 from "../assets/fonts/Poppins/Poppins-Medium.ttf";
import PoppinsSemiBold600 from "../assets/fonts/Poppins/Poppins-SemiBold.ttf";

import BackgroundImage from "../assets/img/restaurant.webp";

const GlobalStyle = styled.createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    border: 0;
    box-sizing: border-box;
    list-style: none;
    text-decoration: none;
  }

  :root {
     --color-bg: #fff;
     --color-bg2: rgba(155, 199,196); 
    --color-bg-variant1: #2c2c6c;
    --color-bg-variant:rgba(249, 249, 249, 0.4);
    --color-primary: #4db5ff;
    /* --color-primary-variant: rgba(77, 181, 255, 0.4); */
    --color-primary-variant: rgba(249, 249, 249, 0.4);
    --color-white: #fff;
    --color-light: rgba(255, 255, 255, 0.6);
    --color-dark:black;

    --transition: all 400ms ease;

    --container-width-lg: 75%;
    --container-width-md: 86%;
    --container-width-sm: 95%;
    --container-width-xsm: 100%;
  }

  @font-face {
    font-family: "Poppins";
    src: url(${PoppinsLight300}), url(${PoppinsRegular400}),
      url(${PoppinsMedium500}), url(${PoppinsSemiBold600});
  }

  html {
    scroll-behavior: smooth;
    overscroll-behavior-y: contain;
  }

  /* Scrollbar of the navigator */

  ::-webkit-scrollbar {
    display: none;
  }

  body {
    font-family: "Poppins", sans-serif;
    background-color: var(--color-bg);
    color: var(--color-dark);
    line-height: 1.7;
   /* background-image: url(${BackgroundImage});  */
   overscroll-behavior: none;
  }

  /* ========== GENERAL STYLES ========== */

  .container {
    width: var(--container-width-lg);
    margin: 0 auto;
  }

  h1,
  h2,
  h3,
  h4,
  h5 {
    font-weight: 500;
  }

  h1 {
    font-size: 2.5rem;
  }

  // Every components in the app is wrapped in a section

  section {
    margin-top: 2rem;
  }

  // Every section also have an h2 and an h5

  section > h2,
  section > h5 {
    text-align: center;
    color: var(--color-light);
  }

  section > h2 {
    color: var(--color-primary);
    margin-bottom: 3rem;
  }

  // General class for text-light

  .text-light {
    color: var(--color-light);
  }

  a {
    color: var(--color-primary);
    transition: var(--transition);
  }

  a:hover {
    color: var(--color-white);
  }

  .btn {
    width: max-content;
    display: inline-block;
    color: var(--color-primary);
    padding: 0.75rem 1.2rem;
    border-radius: 0.4rem;
    cursor: pointer;
    border: 1px solid var(--color-primary);
    transition: var(--transition);
  }

  .btn:hover {
    background-color: var(--color-white);
    color: var(--color-bg);
    border-color: transparent;
  }

  .btn-primary {
    background-color: var(--color-primary);
    color: var(--color-bg);
  }

  img {
   
  }

  /* ========== MEDIA QUERIES (MEDIUM DEVICES) ========== */

  @media (min-width: 1024px) {
    .container {
      width: var(--container-width-md);
    }

    section {
      margin-top: 3rem;
    }
  }

  /* ========== MEDIA QUERIES (SMALL DEVICES) ========== */

  @media (min-width: 600px) {
    .container {
      width: var(--container-width-sm);
    }

    section > h2 {
      margin-bottom: 2rem;
    }
  }
`;

export default GlobalStyle;
